/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import PropTypes from 'prop-types'
import React from 'react'
import UIkit from 'uikit'


const propTypes = {
  canClose: PropTypes.bool,
  modalContainer: PropTypes.bool,
}
const defaultProps = {
  canClose: false,
  modalContainer: false,
}


class GenericModal extends React.Component {
  constructor(props) {
    super(props)
    this.hide = this.hide.bind(this)
    this.handleOnClickOverlay = this.handleOnClickOverlay.bind(this)
  }

  componentDidMount() {
    this.modal = UIkit.modal(`#${this.props.id}`)
    if (this.props.showOnStart) {
      this.modal.show()
    }
  }

  show() {
    this.modal.show()
    document.getElementById(`scrollable-${this.props.id}`).scrollTop = 0
    document.getElementById(`scrollable-${this.props.id}`).scrollLeft = 0
  }

  hide(clickCancel) {
    if (this.props.reloadOnConfim) {
      window.location.reload()
    }
    this.modal.hide()
    if (clickCancel && this.props.onHideCancel) {
      this.props.onHideCancel()
    }
    if (this.props.onHide) {
      this.props.onHide()
    }
  }

  handleOnClickOverlay() {
    if (this.props.handleOnClickOverlay) return this.props.handleOnClickOverlay()
    if (this.props.closeOnClickOverlay) {
      return this.hide()
    }
    return null
  }

  render() {
    const { noStack } = this.props
    let className = 'uk-modal'
    if (this.props.modalContainer) {
      className = 'uk-modal uk-modal-container'
    }

    let modalOptions = `bg-close: false; esc-close: false; stack: ${noStack ? 'false' : 'true'};`
    if (this.props.canClose) {
      modalOptions = `bg-close: true; esc-close: true; stack: ${noStack ? 'false' : 'true'};`
    }

    return (
      <div
        onClick={this.handleOnClickOverlay}
        data-test-id={this.props['data-test-id']}
        id={this.props.id}
        className={className}
        data-uk-modal={modalOptions}
      >
        <div
          id={`scrollable-${this.props.id}`}
          className={`uk-modal-dialog uk-modal-body${this.props.width ? ` ${this.props.width}` : ''}`}
          uk-overflow-auto={this.props.noOverflow ? null : ''}
          onClick={(e) => e.stopPropagation()}
        >
          <h2>
            {this.props.title}
            {this.props.titleInfo}
          </h2>
          <>
            {this.props.body}
          </>
          {!this.props.noButtons && (
            <p className="uk-text-right">
              <button className={`uk-button ${this.props.buttonType ? this.props.buttonType : 'uk-button-default'} uk-margin-remove-bottom uk-modal-close${this.props.cancelLeft ? ' uk-align-left' : ''}`} onClick={this.hide.bind(this, true)} type="button">{this.props.closeText || 'Cancel'}</button>
              {this.props.buttons}
            </p>
          )}
        </div>
        {this.props.overlayElements}
      </div>
    )
  }
}

GenericModal.propTypes = propTypes
GenericModal.defaultProps = defaultProps

export default GenericModal
